module.exports = __webpack_public_path__ + "static/img/dn4-mayor.f0db4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn4-mayor.png
// module id = 6EzA
// module chunks = 0